"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invariant = void 0;
const invariant = (assertion, errMsg) => {
    if (!assertion) {
        throw new Error(`Invariant error [assertion=${assertion}, errMsg='${errMsg}']`);
    }
};
exports.invariant = invariant;
//# sourceMappingURL=invariant.js.map